"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineDotPill = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var valueFormatter = new Intl.NumberFormat("en-US");
function LineDotPill(_a) {
    var cx = _a.cx, cy = _a.cy, value = _a.value, pillWidth = _a.pillWidth, pillHeight = _a.pillHeight, lineColour = _a.lineColour;
    return (react_1.default.createElement("g", { transform: "translate(".concat(cx - pillWidth / 2 + 1, ", ").concat(cy - pillHeight / 2, ")") },
        react_1.default.createElement("rect", { width: pillWidth, height: pillHeight, rx: pillHeight / 2, fill: lineColour }),
        react_1.default.createElement(kaleidoscope_1.Label, { x: pillWidth / 2, y: pillHeight / 2 + 5, textAnchor: "middle", element: "text", fill: "#fff" }, valueFormatter.format(value))));
}
exports.LineDotPill = LineDotPill;
